export default {
	common: {
		searchForm: {
			query: '查询',
			reset: '重置'
		},
		tableCom: {
			noData: '暂无数据',
			total: '共',
			page: '页',
			pageSize: '条/页',
			confirm: '确定',
			cancel: '取消',
			action: '操作',
			view: '查看',
			edit: '编辑',
			delete: '删除',
			batchDelete: '批量删除',
			upload: '上传',
			download: '下载',
			preview: '预览',
			pleaseSelect: '请选择',
			operationSuccess: '操作成功',
			operationFailed: '操作失败',
			loading: '加载中...',
			required: '必填项不能为空'
		},
		onlinePreview: {
			preview: '预览',
			notSupport: '不支持预览此文件类型'
		},
		attachmentList: {
			title: '附件列表',
			upload: '上传文件',
			download: '下载',
			delete: '删除',
			preview: '预览',
			uploadSuccess: '上传成功',
			uploadFailed: '上传失败',
			deleteSuccess: '删除成功',
			deleteFailed: '删除失败',
			confirmDelete: '确定要删除此文件吗？',
			fileTooLarge: '文件大小不能超过{size}MB',
			onlyOneFile: '只能上传一个文件',
			maxFiles: '最多上传{max}个文件'
		},
		detailDialog: {
			detail: '详情',
			close: '关闭',
			noFiles: '暂无文件',
			unnamedFile: '未命名文件'
		},
		startStopRecord: {
			timeline: '设备启停时间轴',
			deviceName: '设备名称',
			deviceNo: '设备编号',
			status: '状态',
			startTime: '开始时间',
			endTime: '结束时间',
			checkProject: '检查项目',
			checkMethod: '检查方式',
			runTime: '运行时间',
			stopTime: '停机时间',
			dateRangePlaceholder: '选择日期范围',
			running: '运行',
			stopped: '停机'
		}
	},
	passwordForm: {
		oldPassword: '原密码',
		newPassword: '新密码',
		confirmPassword: '确认密码',
		oldPasswordPlaceholder: '请输入原密码',
		newPasswordPlaceholder: '请输入新密码',
		confirmPasswordPlaceholder: '请再次输入新密码',
		required: '{field}不能为空',
		passwordNotMatch: '两次输入的密码不一致',
		passwordLength: '密码长度必须在{min}到{max}个字符之间',
		submit: '提交',
		reset: '重置'
	},
	appDownload: {
		title: '移动端 APP 下载',
		qrcodeTip: '扫描二维码下载 APP',
		manualTitle: '查看操作手册',
		manualPreview: '操作手册'
	},
	aiAssistant: {
		title: 'AI 助手',
		history: '历史记录',
		newChat: '新建对话',
		noMoreHistory: '没有更多历史记录了',
		noHistory: '暂无历史记录',
		loading: '加载更多...',
		selectModel: '选择模型',
		resetChat: '重置对话',
		recommendedQuestions: '推荐问题',
		thinking: '正在思考...',
		inputPlaceholder: '输入您的问题...',
		welcomeMessage: '您好！我是 AI 助手，有什么可以帮助您的吗？',
		question1: '设备异常报警如何快速定位故障原因？',
		question2: '如何制定有效的设备预防性维护计划？',
		question3: '设备数据采集异常如何排查？',
		question4: '如何优化设备运行效率？',
		question5: '设备保养周期如何确定？',
		yesterday: '昨天',
		daysAgo: '{days}天前',
		connectionError: '连接服务器失败，请检查网络',
		connectionErrorMessage: '连接服务器失败，请检查网络。'
	},
	printQrcode: {
		size: '大小',
		color: '颜色',
		qrcode: '二维码',
		print: '打印',
		download: '下载图片'
	},
	lazyImage: {
		loading: '加载中...'
	},
	performance: {
		loadTime: '页面加载时间',
		domReady: 'DOM 解析时间',
		fcp: '首次内容绘制',
		lcp: '最大内容绘制',
		fid: '首次输入延迟',
		cls: '累积布局偏移'
	},
	charts: {
		noData: '暂无数据',
		emptyState: {
			noDataTitle: '当前时段未采集数据',
			noDataDesc: '请选择其他时间段或检查数据采集状态',
			loadErrorTitle: '数据加载失败',
			loadErrorDesc: '请刷新后重试',
			networkErrorTitle: '网络连接错误',
			networkErrorDesc: '请检查网络后重试'
		},
		peakCount: {
			title: '峰值谱线表',
			index: '序号',
			frequency: '频率 (Hz)',
			amplitude: '幅值'
		},
		rotFre: {
			title: '转速分析',
			basic: '基础设置',
			speed: '转速 (r/min)：',
			base: '转频 (Hz)：',
			count: '倍数设置：',
			preview: '转速倍数预览',
			tip: '确定后将在图上按转速对应转频的整数倍绘制标记线，再次点击工具可关闭',
			baseRequired: '请输入大于 0 的转速'
		},
		highChart: {
			delete: '删除',
			peakFind: '寻峰',
			screenshot: '截图',
			setModel: '设置模型',
			setFreCount: '设置频带数量',
			setMarkPoint: '设置标记点',
			deletePoint: '删除标记点',
			setCharFre: '设置特征频率',
			setPeakCount: '设置峰值数量',
			setAbnormal: '设置异常备注',
			singleMarkPointMode: '单标记点模式',
			singleMarkPointModeClose: '单标记点模式关闭',
			freCountSet: '频带数量设置为{count}',
			modelAnnotateSuccess: '标注成功',
			downloadSuccess: '下载成功',
			screenshotSaveSuccess: '截图保存成功',
			screenshotFailed: '截图失败',
			abnormalRemarkSaved: '异常备注已保存',
			alreadyMarked: '该节点已经被标记,请选择其他节点',
			baseline: '基准线',
			auxiliaryLine: '辅助线',
			peak: '峰值',
			freSideInterval: '边频间隔',
			rotFreLabel: '转速',
			noDataCollected: '当前时段未采集数据',
			noDataDesc: '请选择其他时间段或检查数据采集状态',
			dataLoadFailed: '数据加载失败',
			dataLoadFailedDesc: '请稍后重试或联系管理员',
			networkError: '网络连接异常',
			networkErrorDesc: '请检查网络连接后重试'
		}
	},
	dateRange: {
		to: '至',
		startDate: '开始日期',
		endDate: '结束日期'
	},
	maReport: {
		title: '报告选择',
		fileName: '报告名称',
		deviceName: '设备名称',
		createTime: '创建时间'
	},
	deviceModelLibrary: {
		configDeviceModel: '配置设备模型图',
		selectDeviceType: '请选择设备类型',
		addModelImage: '添加模型图',
		editModelImage: '编辑模型图'
	},
	devicePlm: {
		deviceBasicInfo: '设备基础信息',
		editDeviceBasicInfo: '编辑设备基础信息'
	},
	maOrg: {
		selectOrg: '机构选择',
		name: '名称',
		parentName: '上级名称'
	},
	maOrgTree: {
		placeholder: '输入关键字进行过滤',
		expandAll: '展开全部',
		collapseAll: '收起全部'
	},
	generateForm: {
		addDetail: '添加明细',
		clickUpload: '点击上传',
		fileUploadSuccess: '文件上传成功',
		fileUploadTimeout: '文件上传超时,请重新上传',
		fileInfoIncomplete: '文件信息不完整,无法删除',
		fileDeleteSuccess: '文件删除成功',
		fileDeleteFailed: '文件删除失败',
		fileDeleteRequestFailed: '文件删除请求失败',
		exceedUploadLimit: '超出上传数量',
		operation: '操作',
		delete: '删除'
	},
	maDevice: {
		selectDevice: '设备选择',
		deviceId: '设备 ID',
		deviceName: '设备名称',
		number: '编号',
		location: '位置',
		department: '部门',
		keyType: '关键性'
	},
	maRole: {
		selectRole: '角色选择',
		name: '名称',
		code: '编码',
		remark: '备注'
	},
	maPost: {
		selectPost: '岗位选择',
		postCode: '岗位编码',
		postName: '岗位名称'
	},
	maInspectDevice: {
		selectDevice: '设备选择',
		deviceId: '设备 ID',
		deviceName: '设备名称',
		department: '部门'
	},
	maOrgInspect: {
		selectOrg: '机构选择',
		name: '名称',
		parentName: '上级名称'
	},
	maDianjian: {
		title: '点检项目',
		projectId: '项目 ID',
		projectName: '检查项目',
		method: '检查方式'
	},
	hooks: {
		action: '提示',
		confirm: '确定',
		cancel: '取消',
		deleteConfirm: '确定进行删除操作？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		downloadSuccess: '下载文件成功'
	},
	zyForm: {
		confirm: '确定',
		cancel: '取消',
		validationFailed: '验证未通过！',
		requiredField: '{field}不能为空！'
	},
	maUpload: {
		upload: '上传',
		uploading: '上传中',
		success: '上传成功',
		fail: '上传失败',
		image: {
			edit: '编辑',
			view: '查看',
			delete: '删除'
		}
	}
}
